<page-preview [pageName]="marketingPage?.name" [pageType]="pageType" (clearPageEvent)="viewContainerRef.clear()" (setPageEvent)="setPageData($event)"></page-preview>
<ng-template #dynamicPage></ng-template>
